import React, { Component, PropTypes } from 'react';
import { PresetColorPicker, ReactSparkSelectInput } from '../../../widgets/index';
import * as ActionTypes from '../../../../constants/ActionTypes';
import { actions as ThemeActions } from '../../../../store/ThemeStore';
import { connect } from 'react-redux';
import { availableLineHeight, availableBorderRadius } from '../../../../constants/availableFonts';
import { HoverColor } from '../../../widgets/index';
import { range } from 'lodash';
import { onCssLengthChange, onThemePropChange } from '../../../helpers/ThemeStoreHelpers';
import { RemFilter } from '../../../helpers/RemFilter';
import BackgroundPicker from '../../../widgets/BackgroundPicker';
import FontConfigurator from '../../../widgets/FontConfigurator/FontConfigurator';
import CSSLength from '../../../../../lib/css-property-parser/CSSLength';
import { checkPermissionForLevel, checkPermissions } from '../../../../../lib/utils';
import { ACCESS_POINTS_GROUP, ACCESS_POINT_LEVEL } from '../../../../constants/AccessPoints';
import InputTextField from 'components/common/InputTextField';

const prefix = 'form.input';

const FontFamilyPropertySelect = ({ label, values, defaultValue, onChange, isDisabled }) => {
    return (
        <div className="col-lg-6 col-xs-12 col-sm-8">
            <ReactSparkSelectInput
                label={label}
                onChange={onChange}
                isDisabled={isDisabled}
                defaultValue={defaultValue}
                values={values.map(v => {
                    return { key: v.toString(), label: v.toString() };
                })}
            />
        </div>
    );
};

const FontPropertySelect = ({ label, values, defaultValue, onChange, isDisabled }) => {
    return (
        <div className="col-xs-12 col-sm-4">
            <ReactSparkSelectInput
                label={label}
                onChange={onChange}
                isDisabled={isDisabled}
                defaultValue={defaultValue}
                values={values.map(v => {
                    return { key: v.toString(), label: v.toString() };
                })}
            />
        </div>
    );
};

class FormStyles extends Component {
    onPaddingUpdate(paddingFilters, index) {
        const converted = paddingFilters.map(v => v.original.raw.toString());
        return event => {
            converted[index] = paddingFilters[k].filter(event.target.value);
            return dispatch(ThemeActions.modifyThemeKey(`input.padding`, converted.join(' ')));
        };
    }

    render() {
        let paddingFilter1 = this.props.input.padding.split(' ');
        let paddingFilters = this.props.input.padding.split(' ').map(v => new RemFilter(v));
        let paddingsPx = paddingFilters.map(v => v.original.px.toString());
        const normalBorder = this.props.input.border.normal.split(' ');
        const focusBorder = this.props.input.border.focus.split(' ');
        const hoverBorder = this.props.input.border.hover.split(' ');
        const checkboxAndRadioDisabledColor = this.props.input.checkboxAndRadio.disabledText;
        const fontSize = new CSSLength(this.props.input.size, {
            base: 16,
            formatter: (value, unit) => value + unit
        });
        const fontSize2 = fontSize.px;
        const fontSize3 = Math.round(fontSize2.substring(0, fontSize2.length - 2)) + 'px';
        const borderColor = this.props.input.border.normal.split(' ');
        const borderColorHover = this.props.input.border.hover.split(' ');
        const borderColorFocus = this.props.input.border.focus.split(' ');
        const inputLineHeight = new CSSLength(this.props.input.height, {
            base: 16,
            formatter: (value, unit) => value + unit
        });
        
        return (
            <div className="FormStyles spark-panel__content col-xs-12">
                <h4>{this.props.tagNameName}</h4>
                <div className="row">
                    <div className="col-xs-12 col-sm-5 ">
                        <HoverColor
                            colorFourBorder={borderColorHover[2]}
                            colorFourBackground={this.props.input.background.hover}
                            colorFiveBorder={borderColorFocus[2]}
                            colorFiveBackground={this.props.input.background.focus}
                        />
                        <FontConfigurator
                            fontFamilyProperty={'form.input.font'}
                            fontWeightProperty={'form.input.weight'}
                            fontStyleProperty={'form.input.style'}
                            fontFamilyClass={'col-xs-8'}
                            fontStyleClass={'col-xs-4'}
                            fontWeightClass={'col-xs-4'}
                        >
                            <FontPropertySelect
                                label="Font Size"
                                isDisabled={!this.props.permissionEdit}
                                onChange={this.props.onFormFontSizeChange(this.props.tagName)}
                                values={this.props.availableFontSizes}
                                defaultValue={fontSize3}
                            />
                            <FontPropertySelect
                                label="Height"
                                isDisabled={!this.props.permissionEdit}
                                onChange={this.props.onFormLineHeightChange(this.props.tagName)}
                                values={availableLineHeight}
                                defaultValue={_.get(inputLineHeight, 'value', '1.0')}
                            />
                            <FontPropertySelect
                                label="Border Radius"
                                isDisabled={!this.props.permissionEdit}
                                onChange={this.props.onBorderRadiusChange(this.props.tagName)}
                                values={availableBorderRadius}
                                defaultValue={this.props.input.borderRadius}
                            />
                            <div className="col-xs-12 col-sm-4">
                                <ReactSparkSelectInput
                                    label="Top-Bottom Padding"
                                    onChange={this.props.onPaddingUpdate(paddingFilters, 0)}
                                    isDisabled={!this.props.permissionEdit}
                                    defaultValue={paddingsPx[0]}
                                    values={this.props.availableFontSizes.map(v => {
                                        return { key: v.toString(), label: v.toString() };
                                    })}
                                />
                            </div>
                            <div className="col-xs-12 col-sm-4">
                                <ReactSparkSelectInput
                                    label="Left-Right Padding"
                                    onChange={this.props.onPaddingUpdate(paddingFilters, 1)}
                                    isDisabled={!this.props.permissionEdit}
                                    defaultValue={paddingsPx[1]}
                                    values={this.props.availableFontSizes.map(v => {
                                        return { key: v.toString(), label: v.toString() };
                                    })}
                                />
                            </div>
                            <div className="col-lg-2 col-xs-12 col-sm-2">
                                Font
                                {/* input color is corrupted because in system defaults there was color: {disabled: ... } */}
                                <PresetColorPicker
                                    color={
                                        this.props.input.color instanceof Object
                                            ? this.props.input.color.disabled
                                            : this.props.input.color
                                    }
                                    isDisabled={!this.props.permissionEdit}
                                    onColorChange={this.props.onFormFontColorChange(this.props.tagName)}
                                />
                            </div>
                        </FontConfigurator>

                        <h4 className="row margin-top-bottom">Background</h4>
                        <div className="row">
                            {/* <div className="col-lg-2 col-xs-12 col-sm-2">
                            Border
                            <PresetColorPicker color={borderColor[2]} onColorChange={this.props.onFormBorderColorChange('normal')}/>
                            </div> */}
                            <div className="col-lg-2 col-xs-12 col-sm-2">
                                Background
                                <BackgroundPicker
                                    background={this.props.input.background.normal}
                                    preset={this.props.themeColors.primary.colors}
                                    isDisabled={!this.props.permissionEdit}
                                    onChange={property =>
                                        this.props.onFormBackgroundColorChange('normal')({
                                            target: {
                                                value: property
                                            }
                                        })
                                    }
                                />
                            </div>
                            <div className="col-lg-1 col-xs-12 col-sm-2" />
                            {/* <div className="col-lg-2 col-xs-12 col-sm-2">
                            Border
                            (Hover)
                            <PresetColorPicker color={borderColorHover[2]} onColorChange={this.props.onFormBorderColorChange('hover')}/>
                            </div> */}
                            <div className="col-lg-2 col-xs-12 col-sm-2">
                                Background (Hover)
                                <BackgroundPicker
                                    background={this.props.input.background.hover}
                                    preset={this.props.themeColors.primary.colors}
                                    isDisabled={!this.props.permissionEdit}
                                    onChange={property =>
                                        this.props.onFormBackgroundColorChange('hover')({
                                            target: {
                                                value: property
                                            }
                                        })
                                    }
                                />
                            </div>
                            <div className="col-lg-1 col-xs-12 col-sm-2" />
                            <div className="row">
                                {/* <div className="col-lg-2 col-xs-12 col-sm-2">
                                Border
                                (Active)
                                <PresetColorPicker color={borderColorFocus[2]} onColorChange={this.props.onFormBorderColorChange('focus')}/>
                                </div> */}
                                <div className="col-lg-2 col-xs-12 col-sm-2">
                                    Background (Active)
                                    <BackgroundPicker
                                        background={this.props.input.background.focus}
                                        preset={this.props.themeColors.primary.colors}
                                        isDisabled={!this.props.permissionEdit}
                                        onChange={property =>
                                            this.props.onFormBackgroundColorChange('focus')({
                                                target: {
                                                    value: property
                                                }
                                            })
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                        <h4 className="margin-top-bottom">Border</h4>
                        <h5>Normal</h5>
                        <div className="row">
                            <div className="col-lg-4 col-xs-12 col-sm-4">
                                <ReactSparkSelectInput
                                    label="Width"
                                    values={range(20).map(v => ({ key: `${v}px`, label: `${v}px` }))}
                                    isDisabled={!this.props.permissionEdit}
                                    onChange={this.props.onBorderPaddingUpdate('border', normalBorder, 'normal', 0)}
                                    defaultValue={normalBorder[0]}
                                />
                            </div>
                            <div className="col-lg-4 col-xs-12 col-sm-4">
                                <ReactSparkSelectInput
                                    label="Style"
                                    values={[
                                        'solid',
                                        'dotted',
                                        'dashed',
                                        'double',
                                        'groove',
                                        'ridge',
                                        'inset',
                                        'outset',
                                        'none',
                                        'hidden'
                                    ].map((v, k) => ({ key: v.toString(), label: v.toString() }))}
                                    onChange={this.props.onBorderPaddingUpdate('border', normalBorder, 'normal', 1)}
                                    isDisabled={!this.props.permissionEdit}
                                    defaultValue={normalBorder[1]}
                                />
                            </div>
                            <div className="col-lg-4 col-xs-12 col-sm-4">
                                <div>Color</div>
                                <PresetColorPicker
                                    id="theme-text-heading"
                                    color={normalBorder[2]}
                                    isDisabled={!this.props.permissionEdit}
                                    onColorChange={this.props.onBorderPaddingUpdate(
                                        'border',
                                        normalBorder,
                                        'normal',
                                        2
                                    )}
                                />
                            </div>
                        </div>
                        <h5>Hover</h5>
                        <div className="row">
                            <div className="col-xs-12 col-sm-4">
                                <ReactSparkSelectInput
                                    label="Width"
                                    values={range(20).map(v => ({ key: `${v}px`, label: `${v}px` }))}
                                    onChange={this.props.onBorderPaddingUpdate('border', hoverBorder, 'hover', 0)}
                                    isDisabled={!this.props.permissionEdit}
                                    defaultValue={hoverBorder[0]}
                                />
                            </div>
                            <div className="col-xs-12 col-sm-4">
                                <ReactSparkSelectInput
                                    label="Style"
                                    values={[
                                        'solid',
                                        'dotted',
                                        'dashed',
                                        'double',
                                        'groove',
                                        'ridge',
                                        'inset',
                                        'outset',
                                        'none',
                                        'hidden'
                                    ].map((v, k) => ({ key: v.toString(), label: v.toString() }))}
                                    onChange={this.props.onBorderPaddingUpdate('border', hoverBorder, 'hover', 1)}
                                    isDisabled={!this.props.permissionEdit}
                                    defaultValue={hoverBorder[1]}
                                />
                            </div>
                            <div className="col-xs-12 col-sm-4">
                                <div>Color</div>
                                <PresetColorPicker
                                    id="theme-text-heading"
                                    color={hoverBorder[2]}
                                    isDisabled={!this.props.permissionEdit}
                                    onColorChange={this.props.onBorderPaddingUpdate('border', hoverBorder, 'hover', 2)}
                                />
                            </div>
                        </div>
                        <h5>Focus</h5>
                        <div className="row">
                            <div className="col-xs-12 col-sm-4">
                                <ReactSparkSelectInput
                                    label="Width"
                                    values={range(20).map(v => ({ key: `${v}px`, label: `${v}px` }))}
                                    onChange={this.props.onBorderPaddingUpdate('border', focusBorder, 'focus', 0)}
                                    isDisabled={!this.props.permissionEdit}
                                    defaultValue={focusBorder[0]}
                                />
                            </div>
                            <div className="col-xs-12 col-sm-4">
                                <ReactSparkSelectInput
                                    label="Style"
                                    values={[
                                        'solid',
                                        'dotted',
                                        'dashed',
                                        'double',
                                        'groove',
                                        'ridge',
                                        'inset',
                                        'outset',
                                        'none',
                                        'hidden'
                                    ].map((v, k) => ({ key: v.toString(), label: v.toString() }))}
                                    onChange={this.props.onBorderPaddingUpdate('border', focusBorder, 'focus', 1)}
                                    isDisabled={!this.props.permissionEdit}
                                    defaultValue={focusBorder[1]}
                                />
                            </div>
                            <div className="col-xs-12 col-sm-4">
                                <div>Color</div>
                                <PresetColorPicker
                                    id="theme-text-heading"
                                    color={focusBorder[2]}
                                    isDisabled={!this.props.permissionEdit}
                                    onColorChange={this.props.onBorderPaddingUpdate('border', focusBorder, 'focus', 2)}
                                />
                            </div>
                        </div>
                        <h4 className="margin-top-bottom">Checkbox And Radio</h4>
                        <h5>Disabled Label</h5>
                        <div className="row">
                            <div className="col-lg-4 col-xs-12 col-sm-4">
                                <div>Color</div>
                                <PresetColorPicker
                                    id="theme-text-heading"
                                    color={checkboxAndRadioDisabledColor}
                                    isDisabled={!this.props.permissionEdit}
                                    onColorChange={this.props.onCheckBoxAndRadioDisabledColorUpdate}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-xs-12 col-sm-1"></div>
                    <div className="col-xs-12 col-sm-5">
                        <InputTextField
                            className="sabre-config-input active-hover-four active-hover-five"
                            style={{
                                //    textAlign: this.props.align,
                                fontFamily: this.props.input.font,
                                color: this.props.input.color,
                                border: this.props.input.border.normal,
                                fontWeight: this.props.input.weight,
                                fontStyle: this.props.input.style,
                                fontSize: fontSize3,
                                lineHeight: this.props.input.lineHeight,
                                borderRadius: this.props.input.borderRadius,
                                padding: this.props.input.padding,
                                background: this.props.input.background.normal,
                                'margin-right': '20px'
                            }}
                            placeholder={this.props.sampleText}
                        />
                        <InputTextField
                            className="sabre-config-input active-hover-four active-hover-five"
                            style={{
                                //    textAlign: this.props.align,
                                fontFamily: this.props.input.font,
                                color: this.props.input.color,
                                border: this.props.input.border.normal,
                                fontWeight: this.props.input.weight,
                                fontStyle: this.props.input.style,
                                fontSize: fontSize3,
                                lineHeight: this.props.input.lineHeight,
                                borderRadius: this.props.input.borderRadius,
                                padding: this.props.input.padding,
                                background: this.props.input.background.normal
                            }}
                            placeholder={this.props.sampleText2}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

FormStyles.propTypes = {
    children: PropTypes.element,
    availableFonts: PropTypes.array,
    availableFontSizes: PropTypes.array,
    availableFontWeights: PropTypes.object,
    settings: PropTypes.object,
    tagNameName: PropTypes.string
};

FormStyles.contextTypes = {
    store: PropTypes.object
};

const mapFormStylesStateToProps = (state, ownProps) => {
    return {
        ...state.app.data.theme.form[ownProps.tagName],
        ...state.theme.form,
        input: state.app.data.theme.form.input,
        permissionEdit: checkPermissionForLevel(
            state.oauth.accessLevel,
            ACCESS_POINTS_GROUP.THEMES,
            ACCESS_POINT_LEVEL.EDIT,
            state.oauth.userPermissionLevels,
            state.app.selected.level
        ),
        themeColors: state.app.data.theme.colors
    };
};

const mapFormStylesDispatchToProps = dispatch => {
    return {
        onFormFontChange: tagName => {
            return event =>
                dispatch({
                    type: ActionTypes.THEME_FORM_SET_THEME_FONT,
                    layer: tagName,
                    font: event.target.value
                });
        },
        onFormFontSizeChange: tagName => {
            return event =>
                dispatch({
                    type: ActionTypes.THEME_FORM_SET_THEME_FONT_SIZE,
                    layer: tagName,
                    size: event.target.value
                });
        },
        onFormFontWeightChange: tagName => {
            return event =>
                dispatch({
                    type: ActionTypes.THEME_FORM_SET_THEME_FONT_WEIGHT,
                    layer: tagName,
                    weight: event.target.value
                });
        },
        onTextDecorationChange: tagName => {
            return event =>
                dispatch({
                    type: ActionTypes.THEME_FORM_SET_THEME_TEXT_DECORATION,
                    layer: tagName,
                    decoration: event.target.value
                });
        },
        onBorderRadiusChange: tagName => {
            return event =>
                dispatch({
                    type: ActionTypes.THEME_FORM_SET_THEME_BORDER_RADIUS,
                    layer: tagName,
                    borderRadius: event.target.value
                });
        },
        onFontStyleChange: tagName => {
            return event =>
                dispatch({
                    type: ActionTypes.THEME_FORM_SET_THEME_FONT_STYLE,
                    layer: tagName,
                    style: event.target.value
                });
        },
        onFormFontColorChange: tagName => {
            return event =>
                dispatch({
                    type: ActionTypes.THEME_FORM_SET_THEME_FONT_COLOR,
                    layer: tagName,
                    color: event.target.value
                });
        },
        onFormBorderColorChange: tagName => {
            return event =>
                dispatch({
                    type: ActionTypes.THEME_FORM_SET_THEME_BORDER_COLOR,
                    layer: tagName,
                    borderColor: event.target.value
                });
        },
        onFormBackgroundColorChange: tagName => {
            return event =>
                dispatch({
                    type: ActionTypes.THEME_FORM_SET_THEME_BACKGROUND_COLOR,
                    layer: tagName,
                    background: event.target.value
                });
        },
        onFormLineHeightChange: tagName => {
            return event =>
                dispatch({
                    type: ActionTypes.THEME_FORM_SET_THEME_LINE_HEIGHT,
                    layer: tagName,
                    lineHeight: event.target.value
                });
        },
        onBorderPaddingUpdate: (border, borderValue, type, index) => {
            const value = borderValue;
            return event => {
                value[index] = event.target.value;
                return dispatch(ThemeActions.modifyThemeKey(`${prefix}.${border}.${type}`, value.join(' ')));
            };
        },
        onCheckBoxAndRadioDisabledColorUpdate: event => {
            const value = event.target.value;
            return dispatch(ThemeActions.modifyThemeKey(`${prefix}.checkboxAndRadio.disabledText`, value));
        },
        onPaddingUpdate: (paddingFilters, index) => {
            const converted = paddingFilters.map(v => v.original.raw.toString());
            return event => {
                converted[index] = paddingFilters[index].filter(event.target.value);
                return dispatch(ThemeActions.modifyThemeKey(`form.input.padding`, converted.join(' ')));
            };
        },
        onCssLengthChange: onCssLengthChange(dispatch, prefix),
        onThemePropChange: onThemePropChange(dispatch, prefix)
    };
};

export default connect(mapFormStylesStateToProps, mapFormStylesDispatchToProps)(FormStyles);



// WEBPACK FOOTER //
// ./src/components/pages/theme/form/Styles.js